import api from '@services/api';
import { FinancialGroup, SubGroup, SubGroupRequestc } from '../models/financalGroup';

/**
 * <p>
 * API endpoints that cover all financial Group and subgroup related CRUD calls
 */
export const financialGroupApi = api.injectEndpoints({
  endpoints: (builder) => ({
    financialGroup: builder.query<FinancialGroup[], void>({
      query: () => ({
        url: encodeURI(`/report/financial-group/list`),
      }),
      providesTags: ['FinancialGroup'],
    }),
    financialSubGroup: builder.query<SubGroup[], SubGroupRequestc | void>({
      query: (param) => {
        const groupCode = param?.groupCode ?? '';
        const excludeRH = param?.excludeRH ?? false;
        return {
          url: encodeURI(`/report/financial-subgroup/search?groupCode=${groupCode}&excludeRH=${excludeRH}`),
        };
      },
      providesTags: ['FinancialGroup'],
    }),
  }),
});

export const { useFinancialGroupQuery, useFinancialSubGroupQuery } = financialGroupApi;
